<template>
    <div class="common-items-center warp">
       <div class="title" v-if="showBlock">{{title}}</div>
       <div class="warp-input" :style='{width:width+"px"}'>
          <slot></slot>  
       </div>
       
    </div>
</template>
<script>
 export default {
    props:{
       title:{
          type:String,
          default:""
       },
       showBlock:{
          type:Boolean,
          default:true,
       },
       width:{
          type:Number,
          default:()=>{ return 150}
       } 
    }
 }
</script>
<style lang="scss" scoped>
   .warp{
     margin-right:0px;
   }
   .title{
     font-size: 14px;
     color: #606266;
     margin-right:10px;
     position: relative;
     bottom:1px;
   } 
   .warp-input{
      margin-right: 10px;
   }
</style>